import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const ToIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#c10000" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M0 0h250v200.3H0z" />
      <g fill="#c10000">
        <path d="M102.8 31.2h39.9v139.6h-39.8z" />
        <path d="M192.6 81v40H53V81z" />
      </g>
    </g>
  </ChakraIcon>
);
